/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

/** AccreditedNetworkResponse describes the return type of accreditedNetwork query */
export type AccreditedNetworkResponse = {
  __typename?: 'AccreditedNetworkResponse';
  error?: Maybe<Scalars['String']>;
  networks?: Maybe<Array<Maybe<Network>>>;
};

/** AddressDataByZipcodeResponse describes the return type of an address */
export type AddressDataByZipcodeResponse = {
  __typename?: 'AddressDataByZipcodeResponse';
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  complement?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  neighborhood?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zipcode?: Maybe<Scalars['String']>;
};

export type AgeRange = {
  max?: InputMaybe<Scalars['Int']>;
  min?: InputMaybe<Scalars['Int']>;
};

/** Defines AggregateOffer schema for schema.org */
export type AggregateOfferSchemaOrg = {
  __typename?: 'AggregateOfferSchemaOrg';
  highPrice?: Maybe<Scalars['String']>;
  lowPrice?: Maybe<Scalars['String']>;
  offerCount?: Maybe<Scalars['String']>;
  priceCurrency?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** Defines the BrandBanner slice that appears on brand screen */
export type BrandBanner = {
  __typename?: 'BrandBanner';
  /** Value of the chepaer plan of the brand */
  cheaperPrice?: Maybe<Scalars['String']>;
  /** Logo of the brand */
  logo?: Maybe<Scalars['String']>;
  /** Text that should be show at BrandBanner */
  text?: Maybe<Scalars['String']>;
};

/**
 * BrandPageResponse describes the return type of a brand page, such as amil, sulamerica.
 * It contains all the slices content, such as banner, products for other brands and the schema.org fields.
 */
export type BrandPageResponse = {
  __typename?: 'BrandPageResponse';
  /** Field to build the banner of the screen */
  banner?: Maybe<BrandBanner>;
  /** A field that show error message */
  error?: Maybe<Scalars['String']>;
  /** A field that has the legal text as value */
  legalText?: Maybe<Scalars['String']>;
  /** A field that contains all the data to show plans for other brands instead of the brand from variables */
  otherBrandProducts?: Maybe<Array<Maybe<HealthProduct>>>;
  /** A field that contains all the data to show plans for current brand */
  sameBrandProducts?: Maybe<SameBrandProducts>;
  /** The structured data based on schema.org */
  schema?: Maybe<BrandPageSchemaOrg>;
  /** The slug of the brand (same as the brandId passed as variable) */
  slug?: Maybe<Scalars['String']>;
};

/** Defines Brand schema for schema.org */
export type BrandPageSchemaOrg = {
  __typename?: 'BrandPageSchemaOrg';
  Brand?: Maybe<BrandSchemaOrg>;
  Offer?: Maybe<OfferSchemaOrg>;
  cheaperProductRelativePath?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sku?: Maybe<Scalars['String']>;
};

/** Defines BrandSchema schema for schema.org */
export type BrandSchemaOrg = {
  __typename?: 'BrandSchemaOrg';
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type City = {
  __typename?: 'City';
  id?: Maybe<Scalars['Int']>;
  microrregiao?: Maybe<CityMicroregiao>;
  nome?: Maybe<Scalars['String']>;
};

export type CityMicroregiao = {
  __typename?: 'CityMicroregiao';
  id?: Maybe<Scalars['Int']>;
  mesorregiao?: Maybe<MesoRegiao>;
  nome?: Maybe<Scalars['String']>;
};

export type CityUf = {
  __typename?: 'CityUF';
  id?: Maybe<Scalars['Int']>;
  nome?: Maybe<Scalars['String']>;
  regiao?: Maybe<MesoRegiaoUf>;
  sigla?: Maybe<Scalars['String']>;
};

/** It is the map that we return to our front-end */
export type HealthProduct = {
  __typename?: 'HealthProduct';
  /** A list of value and labels about the product */
  about?: Maybe<Array<Maybe<ValueAndLabel>>>;
  /** The product brand data */
  brand?: Maybe<ProductBrand>;
  /** Broken variants tells if the product has no prices */
  brokenVariants?: Maybe<Scalars['Boolean']>;
  /** Category of the product */
  category?: Maybe<Scalars['String']>;
  /** The cheaper value formated with R$ and based on variants (0-18 is always the cheaper) */
  cheaperValue?: Maybe<Scalars['String']>;
  /** The product checklist of benefits */
  checks?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** City covered by the product */
  city?: Maybe<Scalars['String']>;
  /** The product description */
  description?: Maybe<Scalars['String']>;
  /** A list of value and labels about the product differentials */
  differentials?: Maybe<Array<Maybe<ValueAndLabel>>>;
  /** A field that has the eligibility boolean value from catalog as value */
  eligibility?: Maybe<Scalars['Boolean']>;
  /** The product sku from catalog */
  id?: Maybe<Scalars['String']>;
  /** A field that has the legal text as value */
  legalText?: Maybe<Scalars['String']>;
  /** The cheaper value based on variants (0-18 is always the cheaper) */
  machineCheaperValue?: Maybe<Scalars['Int']>;
  /** The product name */
  name?: Maybe<Scalars['String']>;
  /** A field that has an url from partner as value */
  partnerUrl?: Maybe<Scalars['String']>;
  partners?: Maybe<Partner>;
  /** A list of prices, based on variants from catalog */
  prices?: Maybe<Array<Maybe<Prices>>>;
  /** The product quali ID for accredited network */
  productInvoiceId?: Maybe<Scalars['String']>;
  /** The product relative path for linking */
  relativePath?: Maybe<Scalars['String']>;
  /** The product schema.org data */
  schema?: Maybe<ProductSchemaOrg>;
  /** A field that exists only when query simulatorResult is called */
  simulator?: Maybe<SimulatorFields>;
  /** The product slug from catalog (used to build urls) */
  slug?: Maybe<Scalars['String']>;
  /** State covered by the product */
  state?: Maybe<Scalars['String']>;
  /** A field that has the target audience data */
  targetAudience?: Maybe<Array<Maybe<TargetAudience>>>;
};

export type HealthSimulatorProduct = {
  __typename?: 'HealthSimulatorProduct';
  brand?: Maybe<HealthSimulatorProductBrand>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Int']>;
};

export type HealthSimulatorProductBrand = {
  __typename?: 'HealthSimulatorProductBrand';
  logo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export enum LeadApps {
  FormsQuali = 'FORMS_QUALI',
  FormsZelas = 'FORMS_ZELAS',
  LeadTrackingQuali = 'LEAD_TRACKING_QUALI',
  LeadTrackingZelas = 'LEAD_TRACKING_ZELAS',
  Quiz = 'QUIZ',
  Simulator = 'SIMULATOR'
}

export type LeadData = {
  abrangencia___quiz?: InputMaybe<Scalars['String']>;
  acomodacao___quiz?: InputMaybe<Scalars['String']>;
  birth_date?: InputMaybe<Scalars['String']>;
  budget?: InputMaybe<Scalars['String']>;
  ces___quiz?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  cnpj?: InputMaybe<Scalars['String']>;
  communication_channel?: InputMaybe<Scalars['String']>;
  company_name?: InputMaybe<Scalars['String']>;
  complement?: InputMaybe<Scalars['String']>;
  contactid_leadzelas?: InputMaybe<Scalars['String']>;
  coparticipacao__clonado_?: InputMaybe<Scalars['String']>;
  cpf?: InputMaybe<Scalars['String']>;
  created_by?: InputMaybe<Scalars['String']>;
  district?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  estado___uf?: InputMaybe<Scalars['String']>;
  firstname?: InputMaybe<Scalars['String']>;
  fonte?: InputMaybe<Scalars['String']>;
  fonte_zd?: InputMaybe<Scalars['String']>;
  gostaria_de_ter_reembolso____simulador?: InputMaybe<Scalars['String']>;
  leadId?: InputMaybe<Scalars['String']>;
  motivo_da_contratacao___quiz?: InputMaybe<Scalars['String']>;
  n__e_idade_0_18_anos?: InputMaybe<Scalars['String']>;
  n__e_idade_19_23_anos?: InputMaybe<Scalars['String']>;
  n__e_idade_24_28_anos?: InputMaybe<Scalars['String']>;
  n__e_idade_29_33_anos?: InputMaybe<Scalars['String']>;
  n__e_idade_34_38_anos?: InputMaybe<Scalars['String']>;
  n__e_idade_39_43_anos?: InputMaybe<Scalars['String']>;
  n__e_idade_44_48_anos?: InputMaybe<Scalars['String']>;
  n__e_idade_49_53_anos?: InputMaybe<Scalars['String']>;
  n__e_idade_54_58_anos?: InputMaybe<Scalars['String']>;
  n__e_idade_59_100_anos?: InputMaybe<Scalars['String']>;
  n__total_de_pessoas?: InputMaybe<Scalars['String']>;
  necessidades_de_saude___quiz?: InputMaybe<Scalars['String']>;
  o_cnpj_esta_ativo_ha_mais_de_6_meses____simulador?: InputMaybe<Scalars['String']>;
  occupation?: InputMaybe<Scalars['String']>;
  opt_in_mkt?: InputMaybe<Scalars['String']>;
  opt_in_parceiros?: InputMaybe<Scalars['String']>;
  origem_da_entrada?: InputMaybe<Scalars['String']>;
  origem_integracao?: InputMaybe<Scalars['String']>;
  perfil_para_cotacao?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  plano_ideal___quiz?: InputMaybe<Scalars['String']>;
  plano_ofertado?: InputMaybe<Scalars['String']>;
  possui_cnpj?: InputMaybe<Scalars['Boolean']>;
  profissionais___quiz?: InputMaybe<Scalars['String']>;
  publico_de_interesse___quiz?: InputMaybe<Scalars['String']>;
  quantas_pessoas_vao_utilizar_o_plano_?: InputMaybe<Scalars['String']>;
  saude_ou_odonto__clonado_?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  states?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  tipo_de_contratacao___quiz?: InputMaybe<Scalars['String']>;
  url_resultado_simulador?: InputMaybe<Scalars['String']>;
  utm_campaign?: InputMaybe<Scalars['String']>;
  utm_content?: InputMaybe<Scalars['String']>;
  utm_medium?: InputMaybe<Scalars['String']>;
  utm_source?: InputMaybe<Scalars['String']>;
  valor_do_plano_ofertado?: InputMaybe<Scalars['String']>;
  valores___quiz?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
  zip_code?: InputMaybe<Scalars['String']>;
};

export type ListSimulatorProcuctsResponse = {
  __typename?: 'ListSimulatorProcuctsResponse';
  alternativeProducts?: Maybe<Array<Maybe<HealthSimulatorProduct>>>;
  error?: Maybe<Scalars['String']>;
  products: Array<Maybe<HealthSimulatorProduct>>;
};

/** LocationsResponse describes the return type of a location */
export type LocationsResponse = {
  __typename?: 'LocationsResponse';
  /** List of cities */
  cities?: Maybe<Array<Maybe<City>>>;
  /** Error message */
  error?: Maybe<Scalars['String']>;
  /** List of states */
  states?: Maybe<Array<Maybe<State>>>;
};

export type MesoRegiao = {
  __typename?: 'MesoRegiao';
  UF?: Maybe<CityUf>;
  id?: Maybe<Scalars['Int']>;
  nome?: Maybe<Scalars['String']>;
};

export type MesoRegiaoUf = {
  __typename?: 'MesoRegiaoUF';
  id?: Maybe<Scalars['Int']>;
  nome?: Maybe<Scalars['String']>;
  sigla?: Maybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  saveLead?: Maybe<SaveLeadResponse>;
};


export type MutationSaveLeadArgs = {
  from: LeadApps;
  leadData: LeadData;
  leadId?: InputMaybe<Scalars['String']>;
  vertical?: InputMaybe<Scalars['String']>;
};

/** Network is a lab or hospital */
export type Network = {
  __typename?: 'Network';
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  specialties?: Maybe<Array<Maybe<Scalars['String']>>>;
  state?: Maybe<Scalars['String']>;
};

/** Defines OfferSchema schema for schema.org */
export type OfferSchemaOrg = {
  __typename?: 'OfferSchemaOrg';
  price?: Maybe<Scalars['String']>;
  priceCurrency?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type Partner = {
  __typename?: 'Partner';
  link?: Maybe<Scalars['String']>;
  websites?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Defines prices of a product */
export type Prices = {
  __typename?: 'Prices';
  /** The range of current variant */
  ageRange?: Maybe<Scalars['String']>;
  /** The machine price of current variant (without R$) */
  machineValue?: Maybe<Scalars['Int']>;
  /** The price of current variant */
  value?: Maybe<Scalars['String']>;
};

/** Defines brand data inside of a product */
export type ProductBrand = {
  __typename?: 'ProductBrand';
  /** Id of the product brand */
  id?: Maybe<Scalars['String']>;
  /** Logo of the product brand */
  logo?: Maybe<Scalars['String']>;
  /** Name of the product brand */
  name?: Maybe<Scalars['String']>;
  /** Slug of the product brand */
  slug?: Maybe<Scalars['String']>;
  /** Sku of the product brand */
  source_id?: Maybe<Scalars['String']>;
};

/** Defines ProductSchema schema for schema.org */
export type ProductSchemaOrg = {
  __typename?: 'ProductSchemaOrg';
  AggregateOffer?: Maybe<AggregateOfferSchemaOrg>;
  Brand?: Maybe<BrandSchemaOrg>;
  description?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sku?: Maybe<Scalars['String']>;
};

export type ProductsTableResponse = {
  __typename?: 'ProductsTableResponse';
  error?: Maybe<Scalars['String']>;
  products?: Maybe<Array<Maybe<HealthProduct>>>;
  rows?: Maybe<Array<Maybe<Array<Maybe<Scalars['String']>>>>>;
};

export type Query = {
  __typename?: 'Query';
  /** A Query that returns accredited network for a sku or qualiId (idProdutoFatura) */
  accreditedNetwork?: Maybe<AccreditedNetworkResponse>;
  /** A Query that returns everything we need to build a brand page, it returns a BrandPageResponse and receive brandId as a required field */
  brandPage?: Maybe<BrandPageResponse>;
  /** A query that returns an address data based on the provided zipcode */
  getAddressDataByZipcode?: Maybe<AddressDataByZipcodeResponse>;
  /**
   * A Query that returns formatted products for health where:
   * sku: is an array of skus based on catalog
   * catalogCategory: has pme as a default value, but can be anything such as alianca, adesao, etc
   */
  healthProductsBySku?: Maybe<Array<Maybe<HealthProduct>>>;
  /**
   * A Query that returns formatted branded products for health where:
   * brand: is required and the id of the brand (bradesco, amil, etc)
   * catalogCategory: has adesao as a default value, but can be anything such as alianca, pme, etc
   */
  listProductsByBrand?: Maybe<Array<Maybe<HealthProduct>>>;
  listSimulatorProducts?: Maybe<ListSimulatorProcuctsResponse>;
  /** A Query that returns states and cities */
  locations?: Maybe<LocationsResponse>;
  /**
   * A Query that returns a table of products where:
   * sku: is an array of skus based on catalog
   * catalogCategory: can be anything such as alianca, adesao
   */
  productsTable?: Maybe<ProductsTableResponse>;
};


export type QueryAccreditedNetworkArgs = {
  catalogCategory: Scalars['String'];
  city?: InputMaybe<Scalars['String']>;
  qualiId?: InputMaybe<Scalars['String']>;
  sku: Scalars['String'];
  state?: InputMaybe<Scalars['String']>;
};


export type QueryBrandPageArgs = {
  brandId: Scalars['String'];
  state?: InputMaybe<Scalars['String']>;
};


export type QueryGetAddressDataByZipcodeArgs = {
  zipcode: Scalars['String'];
};


export type QueryHealthProductsBySkuArgs = {
  catalogCategory: Scalars['String'];
  sku: Array<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  useUrlField?: InputMaybe<Scalars['Boolean']>;
};


export type QueryListProductsByBrandArgs = {
  brand: Scalars['String'];
  catalogCategory?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
};


export type QueryListSimulatorProductsArgs = {
  filterFields: SimulatorFilterFields;
};


export type QueryLocationsArgs = {
  orderBy?: InputMaybe<Scalars['String']>;
  uf?: InputMaybe<Scalars['String']>;
};


export type QueryProductsTableArgs = {
  catalogCategory: Scalars['String'];
  sku: Array<Scalars['String']>;
};

export type RegiaoIntermediaria = {
  __typename?: 'RegiaoIntermediaria';
  UF?: Maybe<CityUf>;
  id?: Maybe<Scalars['Int']>;
  nome?: Maybe<Scalars['String']>;
};

/** Defines the SameBrandProducts slice that appears on brand screen */
export type SameBrandProducts = {
  __typename?: 'SameBrandProducts';
  /** List of HealthProduct for the slice */
  list?: Maybe<Array<Maybe<HealthProduct>>>;
  /** Description of the slice */
  text?: Maybe<Scalars['String']>;
  /** Title of the slice */
  title?: Maybe<Scalars['String']>;
};

export type SaveLeadResponse = {
  __typename?: 'SaveLeadResponse';
  error?: Maybe<Scalars['String']>;
  leadId?: Maybe<Scalars['String']>;
};

export type SimulatorFields = {
  __typename?: 'SimulatorFields';
  /** A field that exists only at simulator where the prices of variants are added (value withou mask) */
  machinePrice?: Maybe<Scalars['Int']>;
  /** A field that exists only at simulator where the prices of variants are added */
  price?: Maybe<Scalars['String']>;
};

export type SimulatorFilterFields = {
  ageRange: Array<AgeRange>;
  apartment_accommodation: Scalars['Boolean'];
  budget: Scalars['Int'];
  co_participation: Scalars['Boolean'];
  national_coverage: Scalars['Boolean'];
};

export type State = {
  __typename?: 'State';
  id?: Maybe<Scalars['Int']>;
  nome?: Maybe<Scalars['String']>;
  regiao?: Maybe<StateRegion>;
  sigla?: Maybe<Scalars['String']>;
};

export type StateRegion = {
  __typename?: 'StateRegion';
  id?: Maybe<Scalars['Int']>;
  nome?: Maybe<Scalars['String']>;
  sigla?: Maybe<Scalars['String']>;
};

export type TargetAudience = {
  __typename?: 'TargetAudience';
  /** The agreement of the target audience */
  agreement?: Maybe<Scalars['String']>;
  /** The occupation of the target audience */
  occupation?: Maybe<Scalars['String']>;
};

export type ValueAndLabel = {
  __typename?: 'ValueAndLabel';
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type SaveLeadMutationVariables = Exact<{
  leadData: LeadData;
  from: LeadApps;
}>;


export type SaveLeadMutation = { __typename?: 'Mutation', saveLead?: { __typename?: 'SaveLeadResponse', leadId?: string | null } | null };

export type GetAddressDataByZipcodeQueryVariables = Exact<{
  zipcode: Scalars['String'];
}>;


export type GetAddressDataByZipcodeQuery = { __typename?: 'Query', getAddressDataByZipcode?: { __typename?: 'AddressDataByZipcodeResponse', address?: string | null, city?: string | null, complement?: string | null, state?: string | null, source?: string | null, neighborhood?: string | null, zipcode?: string | null, error?: string | null } | null };

export type ListSimulatorProductsQueryVariables = Exact<{
  filterFields: SimulatorFilterFields;
}>;


export type ListSimulatorProductsQuery = { __typename?: 'Query', listSimulatorProducts?: { __typename?: 'ListSimulatorProcuctsResponse', error?: string | null, products: Array<{ __typename?: 'HealthSimulatorProduct', id?: string | null, name?: string | null, description?: string | null, price?: number | null, brand?: { __typename?: 'HealthSimulatorProductBrand', name?: string | null, logo?: string | null } | null } | null>, alternativeProducts?: Array<{ __typename?: 'HealthSimulatorProduct', id?: string | null, name?: string | null, description?: string | null, price?: number | null, brand?: { __typename?: 'HealthSimulatorProductBrand', name?: string | null, logo?: string | null } | null } | null> | null } | null };

export type LocationsQueryVariables = Exact<{
  uf?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Scalars['String']>;
}>;


export type LocationsQuery = { __typename?: 'Query', locations?: { __typename?: 'LocationsResponse', error?: string | null, states?: Array<{ __typename?: 'State', id?: number | null, sigla?: string | null, nome?: string | null, regiao?: { __typename?: 'StateRegion', id?: number | null, sigla?: string | null, nome?: string | null } | null } | null> | null, cities?: Array<{ __typename?: 'City', id?: number | null, nome?: string | null, microrregiao?: { __typename?: 'CityMicroregiao', id?: number | null, nome?: string | null, mesorregiao?: { __typename?: 'MesoRegiao', id?: number | null, nome?: string | null, UF?: { __typename?: 'CityUF', id?: number | null, sigla?: string | null, nome?: string | null, regiao?: { __typename?: 'MesoRegiaoUF', id?: number | null, sigla?: string | null, nome?: string | null } | null } | null } | null } | null } | null> | null } | null };


export const SaveLeadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveLead"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"leadData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LeadData"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"from"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LeadApps"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveLead"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"leadData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"leadData"}}},{"kind":"Argument","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leadId"}}]}}]}}]} as unknown as DocumentNode<SaveLeadMutation, SaveLeadMutationVariables>;
export const GetAddressDataByZipcodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAddressDataByZipcode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zipcode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAddressDataByZipcode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"zipcode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zipcode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"complement"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"neighborhood"}},{"kind":"Field","name":{"kind":"Name","value":"zipcode"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<GetAddressDataByZipcodeQuery, GetAddressDataByZipcodeQueryVariables>;
export const ListSimulatorProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListSimulatorProducts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterFields"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SimulatorFilterFields"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listSimulatorProducts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filterFields"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterFields"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}},{"kind":"Field","name":{"kind":"Name","value":"alternativeProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<ListSimulatorProductsQuery, ListSimulatorProductsQueryVariables>;
export const LocationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Locations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uf"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"uf"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uf"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"states"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sigla"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"regiao"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sigla"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"microrregiao"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"mesorregiao"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"UF"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sigla"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"regiao"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sigla"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<LocationsQuery, LocationsQueryVariables>;